import './App.css';
import Lightning from './world/AmbientLight'
import Camera from './world/Camera';
import Box from './objects/Box'
import Plane from './objects/Plane'
import Cylinder from './objects/Cylinder'
import { OrbitControls, Stars, Environment } from '@react-three/drei';
import Effects from './world/Effects'

function App() {
  return (
    <>
      <fog args={['#222222', 0.6, 2.8]} />
      <Camera />
      <OrbitControls />
      <Environment files="textures/studio.hdr" />
      <Lightning args={[0xffffbb, 0x080820, 1]}/>
      <Box position={[0, 0, 0]}/>
    </>
  );
}

export default App;
